<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-06-29 14:44:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-29 15:55:53
-->
<template>
  <div class="jumpminiprogram_con">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
      class="follow-box"
    >
      <div
        class="follow-info"
        :style="{
          'font-size': datas.wordSize + 'px',
          'font-weight': datas.isBold ? 'bold' : 'normal',
          'font-style': datas.isTilt ? 'italic' : 'normal',
          'text-decoration': datas.isUnderLine ? 'underline' : 'none',
          color: datas.wordColor,
        }"
      >
        {{ datas.followDesc }}
      </div>
      <div class="follow-pic">
        <img
          v-if="(!datas.appId && !datas.username) || !datas.appPath"
          class="btn_con"
          :src="datas.btnImgUrl || defaultImg"
          alt=""
          @click="handleShowTips"
        />
        <!--wx-open-launch-weapp中图片使用 :src识别不了，使用{{}}传变量 -->
        <wx-open-launch-weapp
          v-else
          id="launch-btn"
          style="width: 100%"
          :appid="datas.appId"
          :username="datas.username"
          :path="datas.appPath"
          @error="handleToPageError"
        >
          <script type="text/wxtag-template">
            <style>
              .btn_con {

                width: 50px;
                height: 22px;
              }

            </style>

            <div ><img class="btn_con" src="{{datas.btnImgUrl || defaultImg}}" alt="" /></div>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Jumpminiprogram",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },
  methods: {
    handleShowTips() {
      this.$toast("请在后台配置完整的小程序信息！");
    },
    handleToPageError(e) {
      this.$toast(e.detail.errMsg);
    },
  },
};
</script>

<style lang="scss" scoped>
.jumpminiprogram_con {
  position: relative;
  width: 100%;
  .follow-box {
    display: flex;

    justify-content: space-between;
    align-items: center;
    .follow-pic {
      width: 120px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .follow-info {
      flex: 1;
    }
  }
}
</style>
